import React from "react";
import { RiInstagramLine } from "react-icons/ri";
import mail_icon from "../../Assets/mail.png";
import twiter_icon from "../../Assets/twiter.png";
import result_character from "../../Assets/result_character.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SideBar = ({ item, onViewFullResult }) => {
  const { t } = useTranslation("profile");
  const navigate = useNavigate();
  const location = useLocation();

  const handleViewFullResult = () => {
    if (onViewFullResult) {
      onViewFullResult();
      return;
    }

    navigate({ pathname: '/detail_result_page', search:location.search });
  };

  return (
    <div className="h-full w-full">
      <div className="h-full bg-[#EDEDED] px-4 py-8 flex flex-col gap-6 rounded-2xl sm-max:px-4 sm-max:py-5 md-max:gap-5">
        <div className="flex flex-col items-center gap-4 sm-max:items-start">
          <div className="flex flex-col items-center gap-4 sm-max:flex-row sm-max:items-center">
            <img
              src={item?.imageUrls?.split(',')[0] ? item.imageUrls.split(',')[0] : result_character}
              alt="result Character"
              className="object-cover w-[7.125rem] h-[7.125rem] rounded-full"
            />
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2 sm-max:gap-0">
                <p className="text-xl text-[#3976f9] font-semibold text-center sm-max:text-left">
                  {item?.name}
                </p>
                {/* <p className="text-xl text-center sm-max:text-start">
                  {item.prediction?.mbti.entity.code}-
                  {item.prediction?.holland.entity.code}
                </p> */}
              </div>
              <div className="flex items-center gap-6 lg:hidden md-max:hidden sm-max:flex">
                <img src={mail_icon} alt="icon" className="w-[25px] h-[20px]" />
                <img src={twiter_icon} alt="icon" className="w-[20px] h-[20px]" />
                <RiInstagramLine color="#1C75BC" className="w-6 h-6" />
              </div>
            </div>
          </div>
          {item?.simpleDesc && (
            <p className="text-center md-max:text-left">{item.simpleDesc}</p>
          )}
        </div>
        <div className="flex flex-col gap-6 items-center md-max:gap-4 sm-max:items-start">
          <div>
            <button onClick={handleViewFullResult} className="bg-[#1c75bc] px-[3rem] py-[1rem] rounded-lg text-white">
              {t("sideBar.viewFullResult")}
            </button>
          </div>
          <div className="flex flex-col gap-4 items-center justify-center border-t-2 pt-5 md-max:border-none md-max:pt-0 sm-max:hidden">
            <p>{t("sideBar.shareYourResults")}</p>
            <div className="flex items-center gap-4">
              <img src={mail_icon} alt="icon" className="w-[25px] h-[20px]" />
              <img src={twiter_icon} alt="icon" className="w-[20px] h-[20px]" />
              <RiInstagramLine color="#1C75BC" className="w-6 h-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
